import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import '../../css/forms/Roles.css';

const Roles = () => {
  const roles = [
    {
      id: 1,
      title: "Ambassador Manager", 
      company: "Romulus Media",
      type: "Part-Time",
      location: "Remote",
      description: "Manage program ambassadors nationwide and optimize performance.",
      link: "/ambassador-manager"
    },
    {
      id: 2,
      title: "Acorns Campus Ambassador",
      company: "Acorns (via Romulus Media)",
      type: "Part-Time",
      location: "Your Campus",
      description: "Promote financial literacy and represent Acorns on your campus.",
      link: "/acorns-ambassador"
    },
    {
      id: 3,
      title: "Soluna Campus Ambassador",
      company: "Soluna (via Romulus Media)",
      type: "Part-Time",
      location: "NJ Campuses",
      description: "Promote mental wellness and represent Soluna on your NJ campus.",
      link: "/soluna-ambassador"
    },
    {
      id: 4,
      title: "Content Creator (Social Media)",
      company: "Romulus Media",
      type: "Flexible",
      location: "Remote",
      description: "Create authentic content for brand partnerships in your niche.",
      link: "/creator"
    },
    {
      id: 5,
      title: "Campus Ambassador",
      company: "Romulus Media",
      type: "Part-Time / Flexible",
      location: "Your Campus",
      description: "Join one of the most exciting and rewarding ambassador programs designed to empower students to connect, create, and inspire!",
      link: "/campus-ambassador-2026"
    }
    // {
    //   id: 6,
    //   title: "Research Ambassador",
    //   company: "Romulus Media",
    //   type: "Part-Time / Flexible",
    //   location: "Your Campus",
    //   description: "Help collect valuable data by encouraging students on your campus to complete research surveys. Maximize submissions and make an impact!",
    //   link: "/research-ambassador"
    // }
  ];

  return (
    <div className="roles-container">
      <Helmet>
        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      </Helmet>

      <div className="roles-header">
        <h1>Available Opportunities</h1>
        <p>Join our team and help shape the future of campus marketing and creator partnerships!</p>
      </div>

      <div className="roles-grid">
        {roles.map(role => (
          <div key={role.id} className="role-card">
            <div className="role-card-header">
              <h2>{role.title}</h2>
              <span className="company">{role.company}</span>
            </div>
            <div className="role-meta">
              <span className="meta-item">{role.type}</span>
              <span className="meta-item">{role.location}</span>
            </div>
            <p className="role-description">{role.description}</p>
            <Link to={role.link} className="apply-button">Apply Now</Link>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Roles;